import { Typography } from "@mui/material";
import React from "react";

export default function Text({ children }) {
  return <Typography color="text.secondary">{children}</Typography>;
}
